import { GamePlace, KING_VALUE } from 'constants/cards';
import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Store } from 'game/store/gameStore';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';

// The priority of the area for card selection:
// 1. Freecell
// 2. Tableau (hidden cards)

export function findFreeCellMagic(game: SolitaireGame) {
    let item: MagicItem | null = null;

    for (let i = 0; i < 3; i++) {
        switch (i) {
            case 0:
                // item = checkHint1(game); //freecell can always move to foundation
                break;
            case 1:
                item = checkHint2(game);
                break;
        }
        if (item) return item;
    }
    return null;
}
function getCardFromPlace(inactiveCards: Card[], game: SolitaireGame) {
    if (inactiveCards.length === 0) return null;

    const sequencesColumns = game.columns.map((column) => column.getSequences());

    const validCardsToMove = [] as {
        priority: number;
        moveCard: Card;
        to: GameBoardPlace;
        place: MagicPlace;
        targetCard: Card;
    }[];
    sequencesColumns.forEach((sequences) => {
        sequences.forEach((s) => {
            if (s.length === 0) return;
            const lastCard = s[s.length - 1];
            const firstCard = s[0];
            for (let index = 0; index < inactiveCards.length; index++) {
                const c = inactiveCards[index];

                if (lastCard.canDropInColumn(c)) {
                    validCardsToMove.push({
                        priority: s.length,
                        moveCard: c,
                        to: game.getCardBoardPlace(lastCard),
                        place: MagicPlace.AFTER,
                        targetCard: lastCard,
                    });
                }
                if (c.canDropInColumn(firstCard)) {
                    validCardsToMove.push({
                        priority: s.length,
                        moveCard: c,
                        to: game.getCardBoardPlace(firstCard),
                        place: MagicPlace.BEFORE,
                        targetCard: firstCard,
                    });
                }
            }
        });
    });
    validCardsToMove.sort((a, b) => b.priority - a.priority);
    if (validCardsToMove.length) {
        const { moveCard, to, place, targetCard } = validCardsToMove[0];
        return new MagicItem(moveCard, to, place, targetCard);
    }
    return null;
}
function checkHint1(game: SolitaireGame) {
    // ==== CHECK 1: Tableau (hidden cards). ====
    // If there is an empty column, MW draws a King.
    // MW select cards for the foundation area (starting with the smaller card).
    // Creating or continuing any sequence in the tableau area.
    const hiddenCards = [] as Card[];
    game.freeCells.forEach((fr) => {
        if (!fr.cards.length) return;
        const card = fr.cards[0];
        const targetFoundation = game.foundations.find((f) => f.canDropCard([card]));
        if (targetFoundation) return;
        const targetColumn = game.columns.find((c) => c.canDropCards([card]));
        if (targetColumn) return;
        hiddenCards.push(card);
    });
    return getCardFromPlace(hiddenCards, game);
}

function checkHint2(game: SolitaireGame) {
    const inactiveCards = [] as Card[];
    game.columns.forEach((column) => {
        column.cards
            .filter((c) => !c.active)
            .forEach((c) => {
                inactiveCards.push(c);
            });
    });
    inactiveCards.sort((a, b) => a.value - b.value);
    for (let i = 0; i < inactiveCards.length; i++) {
        const c = inactiveCards[i];
        const canMoveToFoundation = game.foundations.find((f) => f.canDropCard([c]));
        if (canMoveToFoundation) {
            return new MagicItem(c, canMoveToFoundation, MagicPlace.AFTER, null);
        }
    }

    return null;
}
